// extracted by mini-css-extract-plugin
module.exports = {"recentAction":"RecentActionsCard_recentAction__wIa3i","wrapper":"RecentActionsCard_wrapper__NrvZi","isMobile":"RecentActionsCard_isMobile__eNalU"};